import chinaMPSAsset from './../assets/images/chinaMPS.png';
import React from 'react';
import { withRouter } from 'react-router-dom';

import styles from './css/Footer.module.css';

const Footer = (props) =>
  props.location.pathname !== '/' && (
    <footer
      className={[
        styles.footer,
        'page-footer',
        'font-small',
        'blue',
        props.className && props.className,
      ].join(' ')}
    >
      <div className={['footer-copyright', 'text-center', 'py-3'].join(' ')}>
        {`© ${import.meta.env.REACT_APP_COPYRIGHT_YEAR} Matson Inc, All rights reserved. | `}
        <a className={styles.footerText} href="https://www.matson.com">
          Matson Home
        </a>
        {'| '}
        <a className={styles.footerText} href="https://www.matson.com">
          {' '}
          Terms & Conditions
        </a>
        <a
          className={styles.footerText}
          href={import.meta.env.REACT_APP_CHINA_ICP_URL}
        >
          {`${import.meta.env.REACT_APP_CHINA_ICP} `}
        </a>
        {import.meta.env.REACT_APP_CHINA_MPS && (
          <a href={import.meta.env.REACT_APP_CHINA_MPS_URL} rel="noreferrer" target="_blank">
            |
            <img
              src={chinaMPSAsset}
              alt=" MPS "
              className={styles.mpsIcon}
            />
            {`${import.meta.env.REACT_APP_CHINA_MPS} `}
          </a>
        )}
      </div>
    </footer>
  );

export default withRouter(Footer);
